import { useCallback, useState } from 'react';

function useExpander(initialValue = false) {
    const [expanded, setExpanded] = useState(initialValue);
    const onToggle = useCallback(
        function toggleExpanded() {
            setExpanded(v => !v);
        },
        [setExpanded]
    );

    return [expanded, onToggle];
}

export default useExpander;
